module.exports = __webpack_public_path__ + "static/media/isaque.6643ff94.jpeg";